import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";

export default function Lideres() {
  const [nombres, setNombres] = useState([]);
  const BASE_URL = useOutletContext();

  useEffect(() => {
    fetch(`${BASE_URL}/models.php`, {
      method: 'POST', // 👈 importante
      headers: {
        'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
      },
      body: JSON.stringify({ page: 'lideres' })
    })
      .then((res) => res.json())
      .then((data) => setNombres(data))
      .catch((error) => console.error("Error al obtener líderes:", error));
  }, [BASE_URL]);

  const formatearNombre = (nombre) => nombre.toLowerCase().replace(/\s+/g, "");

  return (
    <div>
      <h1>Lista de Líderes</h1>
      <ul>
        {nombres.map((nombre, index) => (
          <li key={index}>
            <Link to={`/lideres/${formatearNombre(nombre)}`}>{nombre}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
